<template>
  <v-app id="inspire">
    <SidebarNavTablet v-if="layout === 'tablet'">
      <template #main-app-bar>
        <MainAppBar class="ml-12"/>
      </template>
    </SidebarNavTablet>
    <SidebarNav v-else />
    
    <MainAppBar v-if="layout !== 'tablet'" />
    <MainContent />
    <PdfPreview />
    <OnlineUsersDrawer />
  </v-app>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, computed, provide } from 'vue';
import { useLayout } from '@/composables/useLayout';
import { useUiStore } from '@/store/modules/useUiStore';
import { storeToRefs } from 'pinia';
import PdfPreview from '@/components/pdfs/utility/PdfPreview.vue';
import OnlineUsersDrawer from '@/components/online/OnlineUsersDrawer.vue';

export default defineComponent({
  name: 'MainLayout',
  components: {
    PdfPreview,
    OnlineUsersDrawer,
    MainAppBar: defineAsyncComponent(() => import('./MainAppBar.vue')),
    SidebarNav: defineAsyncComponent(() => import('./SidebarNav.vue')),
    SidebarNavTablet: defineAsyncComponent(() => import('./SidebarNavTablet.vue')),
    MainContent: defineAsyncComponent(() => import('./MainContent.vue')),
  },
  setup() {
    const { layout } = useLayout();
    const uiStore = useUiStore();
    const { drawer } = storeToRefs(uiStore);
    
    const tabletDrawerOpen = computed(() => layout.value === 'tablet' && drawer.value);
    
    return {
      layout,
      tabletDrawerOpen,
    };
  },
});
</script>
